module.exports = __webpack_public_path__ + "img/left.2c18262c.svg";